import css from "./styles.module.scss"; 

type ContainerProps = {
    children: JSX.Element[] | JSX.Element
}

type RowProps = {
    children: JSX.Element[],
    gutterX?: number,
    gutterY?: number,
    style?: React.CSSProperties
}

type ColProps = {
    children: JSX.Element[] | JSX.Element,
    xs?: number,
    sm?: number,
    md?: number,
    lg?: number,
}

export const STKContainer = ( props: ContainerProps ) => {
    return (
        <div className={css.container}>
            {props.children}
        </div>
    )
}

export const STKRow = ( props: RowProps ) => {

    const style = {
        ...props.style,
        '--gutter-x': props.gutterX ? `${props.gutterX}rem` : '',
        '--gutter-y': props.gutterY ? `${props.gutterY}rem` : ''
    } as React.CSSProperties

    return(
        <div className={css.row} style={style}>
            {props.children}
        </div>
    )
}

export const STKCol = ( props: ColProps ) => {

    const style = {
        '--xs': props.xs ? `${props.xs}%` : '',
        '--sm': props.sm ? `${props.sm}%` : '',
        '--md': props.md ? `${props.md}%` : '',
        '--lg': props.lg ? `${props.lg}%` : '',
    } as React.CSSProperties

    return(
        <div className={css.col} style={style}>
            {props.children}
        </div>
    )
}